import React, { FC } from 'react';

import { SortIconStyled, SortIconsWrapperStyled } from 'ui/table.styled';
import { arrowDown, arrowUp } from 'assets/icons';
import { ColumnSorting } from 'helpers/getColumnSorting';
import { SvgWrapper } from 'components/atoms/svg-wrapper';

interface ISortColumnIndicatorProps {
  sortBy: string | null;
}

export const SortColumnIndicator: FC<ISortColumnIndicatorProps> = ({ sortBy }) =>
  sortBy ? (
    <SortIconStyled width={7} height={7} details={sortBy === ColumnSorting.Desc ? arrowUp : arrowDown} />
  ) : (
    <SortIconsWrapperStyled>
      <SvgWrapper width={7} height={7} details={arrowUp} />
      <SvgWrapper width={7} height={7} details={arrowDown} />
    </SortIconsWrapperStyled>
  );
